import { isNodeList } from './functions.js';



/**
*** 指定されたフォーム要素の VALUE を取得する
*** @param {*} フォーム要素
*** @return Boolean
**/

export const getValue = ( target ) => {

  // チェックボックスの value の容れ物
  let valueArray = [];

  // 添付ファイルを配列
  let filesNameArray = [];



  // フォーム要素がノードリストのときは複数あるチェックボックスかラジオボタン
  if( isNodeList(target) ){
    for( const item of target ){
      // ラジオボタン
      if( item.type === 'radio' ){
        if( item.checked ){
          return item.value;
        }
      }
      // チェックボックス
      if( item.type === 'checkbox' ){
        if( item.checked ){
          valueArray.push( item.value );
        }
      }
    }

    return valueArray.join(','); // チェックボックス

  } else {
    // ラジオボタン
    if( target.type === 'radio' || target.type === 'checkbox' ){
      return target.checked ? target.value : null;
    }
    // セレクトボックス
    else if( target.type === 'select-one' ){
      const index = target.selectedIndex;
      // disabled 属性が false のものだけ取得
      if( target[index].disabled === false ){
        return target[index].value;
      }
      return null;
    }
    else {

      // type = 'file'
      if( target.type === 'file' && target.value ){
        for( const file of target.files ){
          filesNameArray.push(file.name);
        }
        return filesNameArray.join(',');
      }

      return target.value ? target.value : null;

    };
  }

};
